export default "__VITE_ASSET__HyNTxCp5__"